import React, { useState } from 'react';
import england_flag from '../../assets/navbar/icon_flag_england.svg';
import spain_flag from '../../assets/navbar/icon_flag_spain.svg';
import logo from '../../assets/navbar/logo_guillespers.svg';
import menu from '../../assets/navbar/menu.svg';
import thunder from '../../assets/navbar/thunder.svg';
import './Header_Style.css';
import Sidenav from '../Sidenav/Sidenav';
import { useTranslation } from "react-i18next";


function Header() {
    const [show, setShow] = useState(false);
    const { i18n } = useTranslation();
    var body = document.getElementById('body');

    function changeToEnglish() {
        i18n.changeLanguage('en');
    }
    function changeToSpanish() {
        i18n.changeLanguage('es');
    }
    return (
        <header>
            <div className="header">
                <div className="container">
                    <img src={ menu } alt="menu" onClick={ 
                        () => {
                            body.style.overflow = 'hidden';
                            window[`scrollTo`]({top: 0, behavior: `smooth`}) 
                            setShow(!show)
                        } 
                    } 
                        className="img_menu" /> 
                    <img src={ logo } alt="logo" className="logo" />
                    <div className="languages"> 
                        <img src={ england_flag } alt="english" className="flag" onClick= { changeToEnglish } />
                        <img src={ spain_flag } alt="spanish" className="flag" onClick= { changeToSpanish } />
                    </div>
                    <img src={thunder} alt="thunder" className="thunder" /> 
                </div>
            </div>
            <Sidenav show={ show } setShow={ setShow } />
        </header>
    )
}

export default Header
